import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { nonPaginatedApolloClient } from 'providers/ApolloClients/NonPaginatedApolloClient';
import { QUERY_groupedPositionsSettingsPage } from 'queries';

const fetchGroupedPositions = nonPaginatedApolloClient();

export const fetchGroupedPositionsConfig = (locationId: string): ISSFBehaviorsOptions => ({
  key: 'ASSIGNED_GROUPED_POSITIONS',
  query: QUERY_groupedPositionsSettingsPage,
  client: fetchGroupedPositions,
  debounceTimeout: 500,
  payloadTransformer: (variables) => ({
    ...variables,
    byRateLessThanOrEqualTo: variables.byRateLessThanOrEqualTo
      ? Number.parseFloat(variables.byRateLessThanOrEqualTo[0])
      : undefined,
    sortAllocatedPositionsByCommunity: Number(locationId),
  }),
  schema: {
    byName: {
      initialValue: '',
    },
    byRateLessThanOrEqualTo: {
      initialValue: undefined,
    },
  },
});
